export default {
  SET_DYNAMIC_ATTRIBUTES: (state, dynamicAttributes) => (state.dynamicAttributes = dynamicAttributes),
}
